export enum WarningType {
  Info = 0,
  Warning = 1,
  Error = 2
}

export interface LogsType {
  Error: string
  Type: WarningType
}
